import { Action, createReducer, on } from '@ngrx/store';

import * as CommonIdAuthActions from '../../actions/common-id/common-id-auth.actions';
import * as CommonIdGetDesiredUniversitiesActions from '../../actions/common-id/common-id-get-desired-universities.actions';
import { CommonIdUser } from '../../models/common-id/common-id-user';
import { CommonIdFindUniversitiesResponse } from 'src/app/models/common-id/common-id-find-universities-response';
import { AppError } from 'src/app/errors/app-error';

interface CommonIdSignInResult {
  success: boolean;
  signedInUser: CommonIdUser | null;
}

interface UpdateSignedInUserIsTermsAgreeResult {
  success: boolean;
}

export interface CommonIdFindUniversitiesResult {
  success: boolean;
  response: CommonIdFindUniversitiesResponse[] | null;
  error: AppError | null;
}

export const commonIdAuthFeatureKey = 'commonIdAuth';

export interface State {
  signedInUser: CommonIdUser | 'none' | null;
  signInResult: CommonIdSignInResult | null;
  updateSignedInUserIsTermAgreeResult: UpdateSignedInUserIsTermsAgreeResult | null;
  savePurchaseResult: boolean | null;
}

export const initialState: State = {
  signedInUser: null,
  signInResult: null,
  updateSignedInUserIsTermAgreeResult: null,
  savePurchaseResult: null
};

const commonIdAuthReducer = createReducer(
  initialState,
  on(CommonIdAuthActions.commonIdSignInSuccess, (state, { user }) => ({
    ...state,
    signedInUser: user,
    signInResult: { success: true, signedInUser: user }
  })),
  on(CommonIdAuthActions.commonIdSignInFailure, state => {
    const next: State = { ...state, signInResult: { success: false, signedInUser: null } };
    return next;
  }),
  on(CommonIdAuthActions.initializeCommonIdSignInResult, state => {
    const next: State = { ...state, signInResult: null };
    return next;
  }),
  on(CommonIdAuthActions.commonIdSignOutSuccess, state => {
    const next: State = { ...state, signedInUser: null };
    return next;
  }),
  on(CommonIdAuthActions.findCommonIdSignedInUserSuccess, (state, { user }) => ({ ...state, signedInUser: user })),
  on(CommonIdAuthActions.findCommonIdSignedInUserFailure, state => {
    const next: State = { ...state, signedInUser: 'none' };
    return next;
  }),
  on(CommonIdAuthActions.commonIdSavePurchaseSuccess, (state, { response, result }) => ({
    ...state,
    signedInUser: { ...(state.signedInUser as object), ...response },
    savePurchaseResult: result
  })),
  on(CommonIdAuthActions.initializeCommonIdSavePurchaseResult, state => {
    const next: State = { ...state, savePurchaseResult: null };
    return next;
  }),

  /* 最新の志望校の取得して志望校一覧を上書き */
  on(CommonIdGetDesiredUniversitiesActions.commonIdGetDesiredUniversitiesSuccess, (state, { response }) => {
    const next: State = {
      ...state,
      signedInUser: { ...(state.signedInUser as CommonIdUser), desiredUniversities: response.desiredUniversities }
    };
    return next;
  })
);

export function reducer(state: State | undefined, action: Action) {
  return commonIdAuthReducer(state, action);
}
